import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import CadastroEcommerce from "./pages/cadastroEcommercePage";
import Login from "./pages/loginPage";
import RecuperarSenha from "./pages/recuperarSenhaPage";
import EnviarEmail from "./pages/enviarEmailPage";
import './App.css';


const AppBrowser = () => {
	return (
		<BrowserRouter>
			<section className="content custom-background">
					<ToastContainer autoClose={7000} />
					<Routes>
						<Route path="/cadastro-loja" element={<CadastroEcommerce />}/>
						<Route path="/recuperar-senha" element={<RecuperarSenha />}/>
						<Route path="/enviar-email" element={<EnviarEmail />}/>
						<Route exact path="/" element={<Login />}/>
						<Route path="*" element={<Navigate to="/" replace />}/>
					</Routes>
					
			</section>
		</BrowserRouter>
  );
}
	

export default AppBrowser;
